/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ListContractsResponse = {
  type: 'all-of',
  contains: [{
    type: 'Response',
  }, {
    properties: {
      data: {
        type: 'array',
        contains: {
          type: 'Contract',
        },
      },
    },
  }],
} as const;
